import React, { useMemo, useState } from 'react';
import { useWinningPremiumCoupons } from '../hooks/useWinningPremiumCoupons';
import WinningPremiumCouponCard from '../components/WinningPremiumCouponCard';

const getTodayString = () => new Date().toISOString().slice(0, 10);

const WinningPremiumCouponsPage = () => {
  const [selectedDate, setSelectedDate] = useState(getTodayString());
  const { coupons, loading, error } = useWinningPremiumCoupons(selectedDate);
  const emptyMessage = useMemo(
    () => `${selectedDate || 'Secili tarih'} icin arsive giren tutan premium kupon yok.`,
    [selectedDate]
  );

  if (loading) return <div className="loading">Tutan premium kuponlar yukleniyor...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="page analysis-page">
      <section className="hero-panel compact premium-coupon-hero">
        <div className="hero-copy">
          <span className="hero-badge premium-hero-badge">
            <img src="/premium-crown.svg" alt="Premium tac" />
            <span>TUTAN PREMIUM KUPONLAR</span>
          </span>
          <h1 className="live-hero-title">BAŞARILI PREMİUM KUPON ARŞİVİ</h1>
          <p>Tum secimleri gelen premium kuponlar burada guven vitrini olarak saklanir.</p>
        </div>
      </section>

      <section className="content-panel">
        <div className="section-heading">
          <div>
            <h2>Tarih Sec</h2>
            <p>Hangi gunun tutan premium kuponlarini gormek istiyorsan o tarihi sec.</p>
          </div>
          <div className="premium-coupon-date-filter">
            <input
              type="date"
              value={selectedDate}
              onChange={(event) => setSelectedDate(event.target.value)}
            />
          </div>
        </div>
      </section>

      {coupons.length === 0 ? (
        <div className="empty">{emptyMessage}</div>
      ) : (
        <div className="analysis-grid winning-archive-grid">
          {coupons.map((coupon) => (
            <WinningPremiumCouponCard key={coupon.id} coupon={coupon} />
          ))}
        </div>
      )}
    </div>
  );
};

export default WinningPremiumCouponsPage;
